import { render, staticRenderFns } from "./ModuleOperationForm.vue?vue&type=template&id=70381f20"
import script from "./ModuleOperationForm.vue?vue&type=script&lang=js"
export * from "./ModuleOperationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports